import { AxiosError } from "axios";
import { defineMessages, useIntl } from "react-intl";

import {
  MutationActions,
  useEntityMutation,
  QueryKeys,
  queryClient,
} from "@/api/core";
import { useApi } from "@/hooks";
import { statusSchema, type Group, type Status } from "@/schemas";
import toast from "@/toast";

import type { ApiError } from "@/types/api";

const messages = defineMessages({
  pinSuccess: {
    id: "status.group_pin.success",
    defaultMessage: "Pinned to group",
  },
});

interface Variables {
  id: string;
}

function usePinStatusToGroup(group: Group, status: Status) {
  const api = useApi();
  const intl = useIntl();

  return useEntityMutation({
    globalQueryKey: QueryKeys.statuses.global,
    action: MutationActions.UPDATE,
    schema: statusSchema,
    mutationFn: (variables: Variables) =>
      api.post<Status>(
        `/api/v1/groups/${group.id}/statuses/${variables.id}/pin`,
      ),
    setNextEntity() {
      return {
        ...status,
        pinned: true,
      };
    },
    onSuccess() {
      queryClient.invalidateQueries({
        queryKey: QueryKeys.statuses.groupTimeline(group.id, true),
      });
      toast.success(intl.formatMessage(messages.pinSuccess));
    },
    onError(error: AxiosError<ApiError>) {
      if (error.response?.status === 422) {
        toast.error(error.response.data.error);
      }
    },
  });
}

export { usePinStatusToGroup };
